import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';


@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
  MessageList: any;
  currentUserData: any;
  isUserAdmin: boolean;
  isUserVendor: boolean;
  value: any;
  btnadmin: boolean;
  btnvend: boolean;
  fromuserid: boolean;
  touserid: boolean;



  constructor(private router: Router, private userService: UserService, private userSerfvice: UserService,
    private dataSharingService: DataSharingService, private vendorDashboardService: VendordashboardService) {
    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;

      }
    );
    this.userService.isUserVendor.subscribe(
      value => {
        this.isUserVendor = value;
      }
    )
  }


  ngOnInit() {

    this.getmessagelist();


  }
  getmessagelist() {
    debugger;
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
        if (this.currentUserData != null) {
          var currentUserId = this.currentUserData.id;
          this.vendorDashboardService.getMessageList(currentUserId).subscribe(
            (data) => {
              this.MessageList = data;
              console.log(this.MessageList);

            }
          )

        }
      }
    )

  }
  markAsRead(id) {
    this.vendorDashboardService.markAsRead(id).subscribe(
      (data) => { console.log("Is Seen Value" + data); }
    );
  }
  deletemessage = function (id) {
    debugger;
    this.vendorDashboardService.deletemessage(id).subscribe(
      (data) => {
        if (data == true) {
          this.getmessagelist();
        }
        else {

        }
      }
    )
  }
}
